import { useState } from 'react';
import { useUtcomApi } from '../../../hooks/useUtcomApi';

export const useCryptoAddress = () => {
  const api = useUtcomApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const getData = async () => {
    try {
      setLoading(true);
      const resp = await api.depositService.getAssignedAddress({ currencyCode: 'UTT' });
      setError('');

      return resp.data.walletDepositAddress;
    } catch (error) {
      setError(error.message);
      return Promise.reject(error);
    } finally {
      setLoading(false);
    }
  };
  return { getData, loading, error };
};
